<template>
  <div class="main">
    <Header
      :show="true"
      title="粉料检测"
      left="prepage"
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh">
      <van-cell
        :value="listQuery.date.range"
        is-link
        @click="listQuery.date.show = true"
      >
        <template #title>
          <span style="font-size: 2vh">时间区间</span>
        </template>
      </van-cell>
      <van-calendar
        v-model="listQuery.date.show"
        type="range"
        :max-range="31"
        :min-date="listQuery.date.min"
        :max-date="listQuery.date.max"
        :default-date="listQuery.date.default"
        color="#ee0a24"
        :style="{ 'padding-bottom': '30px' }"
        @confirm="onConfirmDateChoose"
      />
      <van-cell
        :value="listQuery.status.name"
        is-link
        @click="listQuery.status.show = true"
      >
        <template #title>
          <span style="font-size: 2vh">检测状态</span>
        </template>
      </van-cell>
      <van-action-sheet
        v-model="listQuery.status.show"
        :actions="listQuery.status.actions"
        cancel-text="取消"
        description="请选择待查询的检测状态"
        @select="onSelectStatusChoose"
      />
      <div style="margin: 16px">
        <van-button
          round
          block
          type="info"
          @click="handleClickQuery"
        >
          查询
        </van-button>
      </div>

      <el-table
        ref="table"
        :data="table.data"
        :row-key="handleRowKey"
        :expand-row-keys="expandRowKeys"
        :row-class-name="handleRowClassName"
        :cell-style="handleCellStyle"
        style="width: 100%"
        @row-click="handleTableRowClick"
      >
        <el-table-column
          type="expand"
          width="30px"
        >
          <template slot-scope="{ row }">
            <el-form
              label-position="left"
              inline
              class="demo-table-expand"
            >
              <el-form-item label="序号">
                <span>{{ row.id }}</span>
              </el-form-item>
              <el-form-item label="车牌号">
                <span>{{ row.plateNumber }}</span>
              </el-form-item>
              <el-form-item label="物料">
                <span>{{ row.material }}</span>
              </el-form-item>
              <el-form-item label="供应商">
                <span>{{ row.supplier }}</span>
              </el-form-item>
              <el-form-item label="凭证照片">
                <van-image
                  width="100px"
                  height="100px"
                  :src="row.applyUrl"
                  @click="handleClickPreview(row.applyUrl)"
                >
                  <template #index>
                    凭证照片
                  </template>
                </van-image>
              </el-form-item>
              <el-form-item label="申请人">
                <span>{{ row.createdBy }}</span>
              </el-form-item>
              <el-form-item label="申请时间">
                <span>{{ row.createdTime }}</span>
              </el-form-item>
              <el-form-item label="物料匹配">
                <el-tag
                  v-if="row.match === true"
                  type="success"
                >
                  是
                </el-tag>
                <el-tag
                  v-else
                  type="warning"
                >
                  否
                </el-tag>
              </el-form-item>
              <el-form-item label="是否采样">
                <el-tag
                  v-if="row.isNeedPhoto === true"
                  type="primary"
                >
                  是
                </el-tag>
                <el-tag
                  v-else
                  type="info"
                >
                  否
                </el-tag>
              </el-form-item>
              <el-form-item label="检测照片">
                <van-image
                  width="100px"
                  height="100px"
                  :src="row.qcPhotoUrl"
                  @click="handleClickPreview(row.qcPhotoUrl)"
                >
                  <template #index>
                    检测照片
                  </template>
                </van-image>
              </el-form-item>
              <el-form-item label="罐口">
                <span>{{ row.port }}</span>
              </el-form-item>
              <el-form-item label="状态">
                <el-tag
                  v-if="row.status === '待检测'"
                  type="warning"
                >
                  待检测
                </el-tag>
                <el-tag
                  v-else-if="row.status === '已通过'"
                  type="success"
                >
                  已通过
                </el-tag>
                <el-tag
                  v-else-if="row.status === '已拒绝'"
                  type="danger"
                >
                  已拒绝
                </el-tag>
                <el-tag
                  v-else-if="row.status === '已过期'"
                  type="info"
                >
                  已过期
                </el-tag>
                <el-tag
                  v-else
                  type="info"
                >
                  其他
                </el-tag>
              </el-form-item>
              <el-form-item label="拒绝原因">
                <span>{{ row.rejectReason }}</span>
              </el-form-item>
              <el-form-item label="审核人">
                <span>{{ row.updatedBy }}</span>
              </el-form-item>
              <el-form-item label="审核时间">
                <span>{{ row.updatedTime }}</span>
              </el-form-item>
              <el-form-item
                v-if="checkPermission([32])"
                label="操作"
              >
                <el-button
                  v-if="row.status === '待检测'"
                  type="primary"
                  size="mini"
                  @click="handleClickUpdate(row)"
                >
                  检测
                </el-button>
                <el-button
                  v-else
                  type="info"
                  size="mini"
                  disabled
                >
                  检测
                </el-button>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="序号"
          prop="id"
          align="center"
          width="40"
        >
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="车牌号"
          prop="plateNumber"
          align="center"
          min-width="80"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            {{ row.plateNumber }}
          </template>
        </el-table-column>
        <el-table-column
          label="物料名称"
          prop="material"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            {{ row.material }}
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          prop="grossTime"
          align="center"
          width="90"
        >
          <template slot-scope="{ row }">
            <el-tag
              v-if="row.status === '待检测'"
              type="warning"
            >
              待检测
            </el-tag>
            <el-tag
              v-else
              type="success"
            >
              已检测
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="table.total > 0"
        :total="table.total"
        background
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        :pager-count="table.fullWidth > 380 ? 5 : 3"
        style="margin: 0.6rem 0; text-align: center"
        @current-change="handleClickQuery"
      />
      <div style="height: 1rem; background-color: #ffffff" />
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
import { Dialog, ImagePreview } from "vant";
import { showPhoneAlarm, converImageURL } from "@/global/function.js";
import { parseTime } from "@/utils";
import checkPermission from "@/utils/permission";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";
import { getConfigList as getPortList } from "@/api/port.js";
import { getMaterialCheckList as getList } from "@/api/material.js";

export default {
  name: "ServiceBussinessMaterial",
  components: {
    Header,
    Footer,
  },
  inject: ["reload"],
  data() {
    const EDate = parseTime(new Date(), "{y}/{m}/{d}");
    const dayTimeStamp = new Date(EDate).getTime();
    const beforeTimeStamp = dayTimeStamp - 7 * 24 * 3600 * 1000;
    const SDate = parseTime(beforeTimeStamp, "{y}/{m}/{d}");
    return {
      listQuery: {
        limit: 10,
        page: 1,
        date: {
          show: false,
          min: new Date(2020, 1, 1),
          max: new Date(2030, 12, 31),
          range: SDate + " - " + EDate,
          start: beforeTimeStamp,
          end: dayTimeStamp,
          default: [new Date(SDate), new Date(EDate)],
        },
        type: {
          show: false,
          actions: [
            { name: "全部", value: 9, subname: "" },
            { name: "骨料", value: 1 },
            { name: "粉料", value: 2 },
            { name: "其他", value: 3 },
          ],
          name: "粉料",
          value: 1,
        },
        status: {
          show: false,
          actions: [
            { name: "全部", value: 9, subname: "" },
            { name: "待检测", value: 0 },
            { name: "正常", value: 1 },
            { name: "退货", value: 2 },
          ],
          name: "全部",
          value: 9,
        },
        plateNumber: "",
        verify: 1,
        reason: null,
      },
      applyPhotoShow: false,
      qcPhotoShow: false,
      isLoading: false,
      port: {
        show: false,
        columns: [],
        options: [],
      },
      table: {
        listLoading: false,
        fullWidth: document.documentElement.clientWidth,
        key: 0,
        total: 0,
        data: [],
      },
      expandRowKeys: [],
      handleRowKey(row) {
        return row.id;
      },
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {
    this.handleGetPortList();
    this.handleClickQuery();
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    checkPermission,
    handleClickLeft() {
      this.$router.go(-1);
      // console.log('dashboard-left')
    },
    handleClickRight() {},
    handleTableRowClick(row, column, event) {
      this.$refs.table.toggleRowExpansion(row);
    },
    handleRowClassName({ row, rowIndex }) {
      return "normal-row";
    },
    handleCellStyle({ row, column, rowIndex, columnIndex }) {
      return "";
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth();
      const day = date.getDate();
      return `${year}/${month + 1 > 9 ? month + 1 : "0" + (month + 1)}/${
        day > 9 ? day : "0" + day
      }`;
    },
    onConfirmDateChoose(date) {
      const [start, end] = date;
      this.listQuery.date.show = false;
      this.listQuery.date.range = `${this.formatDate(
        start
      )} - ${this.formatDate(end)}`;
      this.listQuery.date.start = new Date(start).getTime();
      this.listQuery.date.end = new Date(end).getTime();
    },
    onSelectStatusChoose(item) {
      this.listQuery.status.show = false;
      // this.listQuery.status.id = this.listQuery.status.actions.indexOf(item)
      this.listQuery.status.name = item.name;
      if (item.name === "全部") {
        this.listQuery.status.value = 9;
      } else if (item.name === "待检测") {
        this.listQuery.status.value = 0;
      } else if (item.name === "正常") {
        this.listQuery.status.value = 1;
      } else if (item.name === "退货") {
        this.listQuery.status.value = 2;
      }
    },
    handleGetPortList() {
      const data = {};
      getPortList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            const items = data.data;
            this.port.columns = [];
            for (let i = 0; i < items.length; i++) {
              this.port.columns.push(items[i].portName);
              this.port.options.push({
                id: items[i].id,
                name: items[i].portName,
              });
            }
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.listQuery.page++;
        if (
          this.listQuery.limit * (this.listQuery.page + 1) <
          this.table.total
        ) {
          this.handleClickQuery();
        } else {
          showPhoneAlarm(
            true,
            "toast",
            null,
            2000,
            null,
            "拉取水份检测记录",
            "没有新的数据"
          );
        }
      }, 1000);
    },
    portIdToName(value) {
      const len = this.port.options.length;
      for (let i = 0; i < len; i++) {
        if (this.port.options[i].id === value) {
          return this.port.options[i].name;
        }
      }
      return "未知";
    },
    handleClickPreview(url) {
      ImagePreview([url]);
    },
    handleClickQuery() {
      const data = {
        page: this.listQuery.page,
        limit: this.listQuery.limit,
        startDate: this.listQuery.date.start,
        endDate: this.listQuery.date.end,
        status: this.listQuery.status.value,
        plateNumber: this.listQuery.plateNumber,
      };
      getList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            this.table.total = data.data.total;
            const items = data.data.items;
            this.table.data = [];
            for (let i = 0; i < items.length; i++) {
              let status = "未知";
              if (items[i].status === 0) {
                status = "待检测";
              } else if (items[i].status === 1) {
                status = "已通过";
              } else if (items[i].status === 2) {
                status = "已拒绝";
              }
              this.table.data.push({
                id: this.listQuery.limit * (this.listQuery.page - 1) + i + 1,
                serial: items[i].id,
                plateNumber: items[i].plateNumber,
                material: items[i].materialName,
                supplier: items[i].supplierName,
                applyUrl: converImageURL(items[i].credentialsUrl),
                createdBy: items[i].createdBy,
                createdTime: parseTime(
                  items[i].createdTime,
                  "{y}-{m}-{d} {h}:{i}:{s}"
                ),
                match: items[i].match,
                port: this.portIdToName(items[i].port),
                status: status,
                rejectReason: items[i].rejectReason,
                isNeedPhoto: items[i].sampling,
                qcPhotoUrl: converImageURL(items[i].samplingUrl),
                updatedBy: items[i].updatedBy,
                updatedTime: parseTime(
                  items[i].updatedTime,
                  "{y}-{m}-{d} {h}:{i}:{s}"
                ),
              });
            }
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    handleClickUpdate(row) {
      this.$router.push({
        path: "/service/business/material/update",
        query: row,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// 系统样式修改
::v-deep .el-form-item__label {
  width: 20%;
  text-align: right;
  // margin-right: 20px;
}
::v-deep .el-table__expanded-cell[class*="cell"] {
  padding: 20px 10px;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 100%;
}
::v-deep .van-cell__title {
  max-width: 30%;
}
::v-deep .van-cell__value {
  max-width: 70%;
}
::v-deep .el-table th > .cell {
  padding-left: 5px;
  padding-right: 5px;
}
::v-deep .el-table td > .cell {
  padding-left: 5px;
  padding-right: 5px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F7F8FA;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
